
function addDeals(e) {
	e.preventDefault();
	const pta = [];
	const ptr = [];
	const t = e.target.closest('li');
	const url = window.location.search;
	const isSelected = t.classList.contains('selected');
	const existingLabels = window.location.search
		.split('&')
		.filter(param => param.includes('deals='));

	existingLabels.forEach(param => {
		if (!t.parentElement.querySelector(`li[data-filter="${param.split('=')[1]}"]`)) {
			ptr.push(param);				
		}
	});
	if (!t.dataset.filter) {
		t.parentElement.querySelectorAll('li').forEach(li => {
			const isIncluded = url.includes(li.dataset.filter);
			if (li.dataset.filter && !isIncluded) {
				pta.push(`deals=${li.dataset.filter}`);
			} else if (li.dataset.filter && isIncluded && isSelected) {
				ptr.push(`deals=${li.dataset.filter}`);
			}
		});

	} else {
		pta.push(`deals=${t.dataset.filter}`);
	}

	if (!isSelected) {
		changeMultipleParams(e, pta, ptr);
	} else {
		changeMultipleParams(e, [], [...pta, ...ptr]);
	}
}

function addFilter(e, p, coActId = 0, oo = false){
	e.preventDefault();
	window.location.search = addQueryParam(p, coActId, oo);
}

function addQueryParam(p, coActId = 0, only1 = false) {
	const url = window.location.search;
	let params = !!url ? url.split('&').filter(u => !u.includes('page')) : [];
	let path;
	let labelIds = [];
	if (!!coActId && url.includes(p) && p.startsWith('act=')) {
		const allLabels = document.querySelectorAll(`li.sf-labels[data-co-act-id="${coActId}"], li[data-co-act-id="${coActId}"].sf-labels`);
		allLabels.forEach(li => {
			if (li.dataset && li.dataset.labelId) {
				labelIds.push(li.dataset.labelId);
			}
		});
		
		const urlHasLabels = params.some(param => param.trim().startsWith('label='));
		if (labelIds.length === 0 && urlHasLabels) {
			path = params
				.filter(param => {
					const trimmed = param.trim();
					return !trimmed.includes(p.split('=')[0] + '=') && !trimmed.startsWith('label=');
				})
				.join('&');
			return path;
		}
	} else if (!!coActId && document.querySelector(`li.selected.sf-labels[data-co-act-id="${coActId}"]`)?.dataset.labelId) {
		document.querySelectorAll(`li.selected.sf-labels[data-co-act-id="${coActId}"]`).forEach(li => {
			if (li.dataset && li.dataset.labelId) {
				labelIds.push(li.dataset.labelId);
			}
		});
	}
	if (url.includes(p)) {
		if (!!labelIds.length) {
			const lset = new Set(labelIds);
			path = params
				.filter(param => {
					const trimmed = param.trim();
					return !trimmed.includes(p.split('=')[0] + '=') && !(trimmed.startsWith('label=') && lset.has(trimmed.split('=')[1]));
				})
				.join('&');
		} else {
			path = params.filter(param => !param.trim().includes(p.split('=')[0] + '=')).join('&');
		}
	} else if (!only1) {
		path = url.length > 1 ? `${params.join('&')}&${p}` : `?${p}`;
	} else {
		if (url.includes(only1)) {
			path = params.map(param => {
				if (param.includes(only1)) {
					return p;
				}
				return param;
			}).join('&');
		} else {
			params.push(p);
			path = params.join('&');
		}
	}
	return path;
}

function changeMultipleParams(e, pArr = [], excpArr = []) {
	e.preventDefault();
	const url = window.location.search;
	let params = !!url ? url.split('&').filter(u => !u.includes('page')) : [];

	if (excpArr.length) {
		excpArr.forEach(excp => {
			if (url.includes(excp)) {
				params = params.filter(param => !param.includes(excp));
			}
		});
	}
	params.push(...pArr);

	window.location.search =  params.join('&');
}

function addParam(e,p){
    if (typeof $ !== 'undefined' && $('.landing-search').attr('id') === 'new-landing-search' && window.location.pathname.indexOf('/sr') !== 0) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }
        
        if (p.indexOf('duration_option=') === 0) {
            var durationNum = p.split('=')[1];
            var durationTexts = {
                '1': '1-3 days',
                '2': '4-7 days', 
                '3': '8-14 days',
                '4': '15+ days'
            };
            
            if (!window.__expSrParamDateQuery) {
                window.__expSrParamDateQuery = p;
            } else {
                var separator = (window.__expSrParamDateQuery.indexOf('?') === -1) ? '?' : '&';
                var cleaned = window.__expSrParamDateQuery.replace(/[?&]duration_option=[^&]*/g, '');
                window.__expSrParamDateQuery = cleaned + separator + p;
            }
            
            var currentVal = $('.js-desktop-search-input-arrival').val();
            var durationText = durationTexts[durationNum] || '';
            
            if (currentVal && currentVal.trim() && !currentVal.includes('days')) {
                $('.js-desktop-search-input-arrival').val(durationText + ', ' + currentVal);
            } else {
                $('.js-desktop-search-input-arrival').val(durationText);
            }
            
            return;
        }
        
        return;
    }
    
    var url=window.location.href;
    addParamOnUrl(e,p,url);
}

function addParamOnUrl(e,p,url){
    if(url.indexOf(p) > -1){
        newUrl = url.split('?'+p).join('?').split('&'+p).join('').split('?&').join('?');
    }else{
        var separator = (url.indexOf("?")===-1)?"?":"&",
            newParam=separator + p,
            newUrl=url.replace(newParam,"");
            newUrl+=newParam;
    };
	newUrl = removeUrlParameter('page',newUrl);

    window.location.href =newUrl;
}

function addOrReplaceParam(e, param, value){
	if(window.location.href.indexOf(param) > -1){
		var newUrl = removeUrlParameter(param,window.location.href);
		addParamOnUrl(e, param+"="+value, newUrl);
	}
	else{
		addParam(e, param+"="+value);
	}
}

function removeQueryParam(p, query){
	if (!query)
		query=window.location.search;
	query = query.replace(new RegExp(`(?:([?])|[&])${p}(=[^&]*)?`,"g"), "$1");
	qyery = query.replace(/[?][&]/, '?');
	return query;
}

function newAddParam(e,p){
    window.location.search = addQueryParam(p);
}

/*
 * not in use anymore - flagged for removal - 20200716 - Richard
function addParamNoPageReload(p){
	history.pushState({}, null, location.pathname + addQueryParam(p));
}

function removeParamNoPageReload(p){
	history.pushState({}, null, location.pathname + removeQueryParam(p));
}
*/
const parameters = (() => {
	return {
		add: (event, parameter) => {
			var url = window.location.href;
			let newUrl = '';

			if (url.indexOf(parameter) > -1) {
				newUrl = url.split('?'+ parameter).join('?').split('&'+ parameter).join('').split('?&').join('?');
			}
			else {
				let separator = (url.indexOf("?") === -1) ? "?" : "&";
				let newParameter = separator + parameter;
				let	newUrl = url.replace(newParameter, "");
				newUrl += newParameter;
			};

			newUrl = parameters('page', newUrl);

			window.location.href = newUrl;
		},
		remove: (key, sourceURL) => {
			var rtn = sourceURL.split("?")[0],
			param,
			params_arr = [],
			queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

			if (queryString !== "") {
				params_arr = queryString.split("&");
				for (var i = params_arr.length - 1; i >= 0; i -= 1) {
					param = params_arr[i].split("=")[0];
					if (param === key) {
						params_arr.splice(i, 1);
					}
				}

				rtn = params_arr.length > 0
					? rtn + "?" + params_arr.join("&")
					: rtn;
			}
			return rtn;
		}
	}
})();
